import { combineReducers } from 'redux';
import userReducer from './reducers/userReducer';
import employeeReducer from './reducers/employeeReducer';
import overlayReducer from './reducers/overlayReducer';
import weatherReducer from './reducers/weatherReducer';
import firestoreReducer from './reducers/firestoreReducer';
import timeReducer from './reducers/timeReducer';
import loggedInUserReducer from './reducers/loggedInUserReducer';
import currentCustomerReducer from './reducers/currentCustomerReducer';


import { reducer as FormReducer} from 'redux-form'; //assign to alias FormReducer

const rootReducer = combineReducers({
  general: userReducer,
  loggedInUserId: loggedInUserReducer,
  currentCustomerId: currentCustomerReducer,
  employees: employeeReducer,
  overlays: overlayReducer,
  weather: weatherReducer,
  firestore: firestoreReducer,
  time: timeReducer,
  form: FormReducer
})

export default rootReducer;
